import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3000';
console.log('[calculateBatchPricing] Using BACKEND_URL:', BACKEND_URL);
export interface PricingGroup {
  group_id?: string;
  paper_type: string;
  total_pages: number;
  is_color: boolean;
}

export interface TierAppliedInfo {
  success: boolean;
  cost_per_page: number;
  total_cost: number;
  tier_applied: string;
  shop_earning_per_page: number;
  group_id?: string;
  error?: string;
}

export interface BatchPricingResult {
  success: boolean;
  shop_id: string;
  groups: TierAppliedInfo[];
  total_order_cost: number;
  total_shop_earnings: number;
  group_count: number;
}

/**
 * Calculate tiered pricing for multiple print groups
 * Calls backend endpoint which uses Supabase RPC function
 */
export async function calculateBatchPricing(
  shopId: string,
  groups: PricingGroup[]
): Promise<BatchPricingResult> {
  try {
    console.log('[calculateBatchPricing] Calculating pricing for groups:', { shopId, groupCount: groups.length });
    
    const response = await axios.post<BatchPricingResult>(
      `${BACKEND_URL}/shops/${shopId}/calculate-pricing`,
      { groups },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    console.log('[calculateBatchPricing] Pricing calculated:', response.data);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error('[calculateBatchPricing] Axios error:', {
        message: error.message,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        url: error.config?.url
      });
    } else {
      console.error('[calculateBatchPricing] Error calculating pricing:', error);
    }
    throw error;
  }
}
